<template>
    <DFormRow
        :label="__('customers.contracts.easy_marketing_id')"
        :error="errors.easy_marketing_id"
    >
        <DInput
            id="easy_marketing_id"
            :model-value="modelValue"
            @update:modelValue="emit('update:modelValue', $event)"
        />
    </DFormRow>
</template>

<script setup>
defineProps({
    modelValue: {
        type: [String, Number],
        default: null
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

const emit = defineEmits(['update:modelValue'])
</script>
